import { Purchase } from "./csvParser";

type ExportCSVParams = {
    purchases: Purchase[];
    headers: string[];
    filename?: string;
    groupSize?: number;
};

// Convert column header to key name (same logic as DataTable)
const getColumnKey = (header: string): string => {
    return header.trim().replace(/\s+/g, "_").replace(/[()]/g, "");
};

export const exportToCSV = ({
    purchases,
    headers,
    filename = "purchases-export.csv",
    groupSize = 0,
}: ExportCSVParams) => {
    if (purchases.length === 0) {
        console.warn("No purchases to export");
        return;
    }

    // Build display headers in the same order as the UI (DataTable)
    const risk = headers.find((h) => h === "RISK SCORE") || null;
    const itemDesc = headers.find((h) => h === "ITEM DESCRIPTION") || null;
    const vendor = headers.find((h) => h === "VENDOR") || null;

    const priority: string[] = [];
    if (risk) priority.push(risk);
    if (itemDesc) priority.push(itemDesc);
    if (vendor) priority.push(vendor);
    const remaining = headers.filter((h) => !priority.includes(h));
    const displayHeaders = [...priority, ...remaining];

    // Keys mapped exactly like UI (and parser)
    const keysInOrder = displayHeaders
        .map((h) => getColumnKey(h))
        .filter((k) => k !== 'id');

    // Convert purchases to CSV rows following same order and formatting as UI
    const rows = purchases.map((purchase) =>
        keysInOrder.map((key) => {
            const value = purchase[key];
            const display = value === null || value === undefined || value === "" ? "—" : String(value);
            // Escape quotes by doubling them
            return display.replace(/"/g, '""');
        })
    );

    // Combine headers and rows (use UI labels exactly)
    const bodyLines: string[] = [];
    rows.forEach((row, index) => {
        bodyLines.push(row.map((cell) => `"${cell}"`).join(","));

        const isLastRow = index === rows.length - 1;
        if (
            groupSize > 0 &&
            (index + 1) % groupSize === 0 &&
            !isLastRow
        ) {
            bodyLines.push("");
            bodyLines.push("");
        }
    });

    const csvContent = [
        displayHeaders.join(","),
        ...bodyLines
    ].join("\n");

    // Create blob and download
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);

    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

